export const PRIVACY_STATUS = {
  UNKNOWN: 'UNKNOWN',
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC'
};
export const STATUS = {
  UNKNOWN: 'UNKNOWN',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  BLOCKED: 'BLOCKED',
  OFFLINE: 'OFFLINE'
};
export const ROLE = {
  UNDEFINED_ROLE: 'UNDEFINED_ROLE',
  MEMBER: 'MEMBER',
  OWNER: 'OWNER',
  CONTRIBUTOR: 'CONTRIBUTOR'
};
//# sourceMappingURL=constants.js.map